import React, { useContext } from 'react';
import { useLingui } from '@lingui/react';
import Attachments from '../Organismns/Attachments';
import { EditableEmailProperty } from '../Atoms/EditableProperties/EditableEmailProperty';
import { EditableDivInput } from '../Atoms/inputs/EditableDivInput';
import { preChange } from '../Utils/utils';
import { HtmlPlaceholderFormatter } from '../Atoms/Formatter/HtmlPlaceholderFormatter';
import { patchDraft } from '../Service/restapi/messageService';
import { MessageContext } from '../Service/Context/MessageContext';
import EditableRteInput from '../Atoms/inputs/EditableRteInput';

const ChatMessageEditor = ({ event, mainCustomer, eventLocation, customAttributeValues, email }) => {
  const { i18n } = useLingui();

  const { message, changeMessage, lastModified } = useContext(MessageContext);

  function deleteFileAttachment(index) {
    const tmpFiles = message.attachments;
    tmpFiles.splice(index, 1);
    patchDraft(message.id, { attachments: tmpFiles })
      .then((resp) => {
        if (resp.ok) {
          resp.json().then(changeMessage);
        } else {
          console.error('could not delete attachment');
        }
      })
      .catch((error) => {
        console.error({ error });
        console.error('could not delete attachment');
      });
  }

  const styles = {
    subjectAndIcon: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 5,
    },
    container: {
      display: 'flex',
    },
    messageContainer: {
      flex: 2,
      marginTop: 10,
      maxWidth: '100%',
    },
    fullWidth: {
      flex: 1,
    },
  };

  if (!message) {
    return null;
  }

  return (
    <div style={styles.container} className="message-email-pane">
      <div style={styles.messageContainer}>
        <div style={styles.subjectAndIcon}>
          <div style={styles.fullWidth}>
            <EditableEmailProperty
              patchField="subject"
              preChange={(p) => preChange(p, i18n)}
              changeHandler={changeMessage}
              email={email}
              inlinePlaceholder="message.subject"
              name="subject"
              editFormatter={EditableDivInput}
              labelFormatter={HtmlPlaceholderFormatter}
              event={event}
              customer={mainCustomer}
              eventLocation={eventLocation}
              customAttributeValues={customAttributeValues}
              disableTextSelectionPopover
            />
          </div>
        </div>
        <Attachments
          attachments={message.attachments}
          deleteFileAttachment={deleteFileAttachment}
          eventId={event ? event.id : undefined}
        />
        <EditableEmailProperty
          patchField="message"
          preChange={(p) => p}
          changeHandler={changeMessage}
          onInputChange={(m) => changeMessage({ message: m })}
          email={email}
          name="message"
          big
          editFormatter={EditableRteInput}
          editOnly
          event={event}
          customer={mainCustomer}
          eventLocation={eventLocation}
          customAttributeValues={customAttributeValues}
          lastModified={lastModified}
          doNotCheckForSameValue
        />
      </div>
    </div>
  );
};

export default ChatMessageEditor;
